module.exports = __webpack_public_path__ + "img/trash.9cea2c11.svg";